(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/draws/assets/javascripts/draws-utils.js') >= 0) return;  svs.modules.push('/components/numbergames/draws/assets/javascripts/draws-utils.js');

'use strict';

const drawsSingleton = svs.numbergames.draws.internal.getDrawsSingleton();
const {
  productMapping
} = svs.numbergames;
const utilsApi = {
  firstDrawDate: draws => {
    const closeTimes = Object.values(draws).map(draw => new Date(draw.regCloseTime));
    return dateFns.min(closeTimes);
  },
  lastDrawDate: function (draws) {
    let {
      drawCount = 1
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const closeTimes = Object.values(draws).map(draw => {
      const daysBetweenDraws = productMapping.isDaily(draw.productItsId) ? 1 : 7;
      const date = new Date(draw.regCloseTime);
      date.setDate(date.getDate() + (drawCount - 1) * daysBetweenDraws);
      return date;
    });
    return dateFns.max(closeTimes);
  }
};
Object.entries(utilsApi).forEach(_ref => {
  let [key, value] = _ref;
  svs.numbergames.draws.drawsUtils[key] = (products, options) => value(drawsSingleton.findFirstPlayableDraw(products), options);
  svs.numbergames.draws.asyncDrawsUtils[key] = async (products, options) => value(await drawsSingleton.getFirstPlayableDraw(products), options);
});

 })(window);